import React, {useEffect, useState} from 'react';

import NoContent from '../../../../common/component/NoContent/NoContent';
import Loader from '../../../../common/component/Loader/Loader';
import OffcanvasMicaPlus from '../../../offcanvas/MicaPlus/MicaPlus';

import Pagination from '../../../../common/component/Pagination/Pagination';
import currency from '../../../../common/util/currency';

import {useToast} from '../../../../common/hook/toast';

import {useHttpClient} from '../../../../common/hook/http';

import {ListGroup, Row, Col, Button, Card, Tab, Tabs} from 'react-bootstrap';

import './MicaPlus.scss'
import GlobalConst from "../../../../common/global-const";

const MicaPlus = () => {
    const {callAPI} = useHttpClient()
    const {callToast} = useToast()

    // ------------------------------------------------------------------------------------------------------ fetch data
    const [pagination, setPagination] = useState([1, 1])
    const [paginationDisabled, setPaginationDisabled] = useState([false, false])

    const [data, setData] = useState(null)

    const fetchData = async page => {

        setPaginationDisabled(paginationDisabled => [true, paginationDisabled[1]])

        try {
            const responseData = await callAPI(
                `crm/credit/${Number.isInteger(page) ? page : pagination[0]}`
            );

            if (responseData.message) {
                callToast('secondary', null, null, responseData.message);
            } else {

                Number.isInteger(page) && setPagination(pagination => [page, pagination[1]])
                setPaginationDisabled(paginationDisabled => [false, paginationDisabled[1]])

                setData(responseData.result)

            }

        } catch (e) {
            console.error(e);
        }

    }

    useEffect(() => {

        fetchData()

    }, []);

    // -----------------------------------------------------------------------------------------------------------------

    const [offcanvasData, setOffcanvasData] = useState(null);
    const [offcanvasMicaPlusShow, setOffcanvasMicaPlusShow] = useState(false);

    const offcanvasMicaPlusShowHandler = item => {

        setOffcanvasData(() => {
            return item
        })

        setOffcanvasMicaPlusShow(true);

    }

    // -----------------------------------------------------------------------------------------------------------------

    const [tab, setTab] = useState('tab1');
    const [usedPoint, setUsedPoint] = useState(null);

    const selectTabHandler = key => {

        if(key !== tab) setTab(key)

    }

    // -----------------------------------------------------------------------------------------------------------------

    const fetchDataUsedPoint = async page => {

        setPaginationDisabled(paginationDisabled => [paginationDisabled[0], true])

        try {
            const responseData = await callAPI(
                `crm/micaCoinUsedCreditsLog/${Number.isInteger(page) ? page : pagination[1]}`
            );

            if (responseData.message) {
                callToast('secondary', null, null, responseData.message);
            } else {

                Number.isInteger(page) && setPagination(pagination => [pagination[0], page])
                setPaginationDisabled(paginationDisabled => [paginationDisabled[0], false])

                setUsedPoint(responseData.result)

            }

        } catch (e) {
            console.error(e);
        }

    }

    // زمانی که داده اولیه صفحه دریافت شد، tab3 شروع به دریافت داده می کند
    useEffect(() => {

        if (data) {

            fetchDataUsedPoint()

        }

    }, [data])

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <div id="pageAccountMicaPlus" className={data?.credits?.length && Number(data?.totalPages) > 1 ? 'has-page-footer' : null}>
                {
                    data?.credits ? (
                        <Row>
                            <Col xs={12}>
                                <Tabs activeKey={tab} className="flex-nowrap hide-scrollbar" justify onSelect={key => selectTabHandler(key)}>
                                    <Tab eventKey="tab1" title="جزئیات" tabClassName="justify-content-center" className="pt-4">
                                        <Row>
                                            <Col xs={12}>
                                                <h2 className="fw-normal fs-4 pb-1 mb-3 page-title">موجودی اعتبار خرید مجدد {currency(data.customer.availableCredit)} {GlobalConst.currency}</h2>
                                            </Col>
                                        </Row>
                                        <Row className="g-0">
                                            <Col sm={6}>
                                                <Card className="border-0 rounded-0 bg-secondary text-accent-3">
                                                    <Card.Body className="pt-3 pt-sm-4 pb-0 pb-sm-4 px-4">
                                                        <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">اعتبار خرید مجدد دریافت شده</Card.Title>
                                                        <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{currency(data.customer.totalEarnedCredit)} {GlobalConst.currency}</Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col sm={6}>
                                                <Card className="border-0 rounded-0 bg-secondary text-accent-3">
                                                    <Card.Body className="pt-0 pt-sm-4 pb-3 pb-sm-4 px-4">
                                                        <Card.Title as="h5" className="mb-0 mt-1 fw-normal lh-base">اعتبار خرید مجدد مصرف شده</Card.Title>
                                                        <Card.Subtitle as="h3" className="mb-0 mt-0 fw-bold lh-base">{currency(data.customer.totalUsedCredit)} {GlobalConst.currency}</Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Tab>
                                    <Tab eventKey="tab2" title="دریافت اعتبار خرید مجدد" tabClassName="justify-content-center" className="pt-4">
                                        {
                                            data.credits.length ? (
                                                <>
                                                    <ListGroup as="ul" variant="flush" className="my-n2">
                                                        {
                                                            data.credits.map(item => {
                                                                return (
                                                                    <ListGroup.Item as="li" className="px-0 d-flex align-items-center border-bottom-0" key={item.receiptNo}>
                                                                        <div className="me-auto">
                                                                            <div className="fw-500 fs-18px">
                                                                                دریافت {currency(item.credit)} {GlobalConst.currency} اعتبار خرید مجدد
                                                                            </div>
                                                                            <div className="text-primary">{item.created_at}<span className="ms-2">ساعت</span> {item.created_time}</div>
                                                                            <div className="lh-1">{item.title}</div>
                                                                        </div>
                                                                        <Button type="button" className="ms-3" onClick={() => offcanvasMicaPlusShowHandler(item)}>جزئیات</Button>
                                                                    </ListGroup.Item>
                                                                )
                                                            })
                                                        }
                                                    </ListGroup>
                                                    {
                                                        Number(data?.totalPages) > 1 && (
                                                            <div className="py-2 py-md-0 bg-body page-footer">
                                                                <Pagination pagination={pagination[0]} paginationDisabled={paginationDisabled[0]} totalPages={data.totalPages} onClick={res => fetchData(res)}/>
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <div className="py-5">
                                                    <div className="py-5">
                                                        <NoContent text={`تراکنشی وجود ندارد`}/>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </Tab>
                                    <Tab eventKey="tab3" title="مصرف اعتبار خرید مجدد" tabClassName="justify-content-center" className="pt-4">
                                        {
                                            usedPoint?.credits?.length ? (
                                                <>
                                                    <ListGroup as="ul" variant="flush" className="my-n2">
                                                        {
                                                            usedPoint.credits.map((item, index) => {
                                                                return (
                                                                    <ListGroup.Item as="li" className="px-0 d-flex align-items-center border-bottom-0" key={index}>
                                                                        <div className="me-auto">
                                                                            <div className="fw-500 fs-18px">
                                                                                مصرف {currency(item.credit)} {GlobalConst.currency} اعتبار خرید مجدد
                                                                            </div>
                                                                            <div className="text-primary">{item.createdShamsi}<span className="ms-2">ساعت</span> {item.createdTime}</div>
                                                                            <div className="lh-1">{item.title}</div>
                                                                        </div>
                                                                        <Button type="button" className="ms-3" onClick={() => offcanvasMicaPlusShowHandler(item)}>جزئیات</Button>
                                                                    </ListGroup.Item>
                                                                )
                                                            })
                                                        }
                                                    </ListGroup>
                                                    {
                                                        Number(usedPoint.totalPages) > 1 && (
                                                            <div className="py-2 py-md-0 bg-body page-footer">
                                                                <Pagination pagination={pagination[1]} paginationDisabled={paginationDisabled[1]} totalPages={usedPoint.totalPages} onClick={res => fetchDataUsedPoint(res)}/>
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <div className="py-5">
                                                    <div className="py-5">
                                                        <NoContent text={`تراکنشی وجود ندارد`}/>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </Tab>
                                </Tabs>
                            </Col>
                        </Row>
                    ) : (
                        <div className="py-5 my-5">
                            <Loader text="در حال دریافت اطلاعات"/>
                        </div>
                    )
                }
            </div>
            {
                data && (
                    <OffcanvasMicaPlus show={offcanvasMicaPlusShow} onHide={() => setOffcanvasMicaPlusShow(false)} data={offcanvasData}/>
                )
            }
        </>
    )
}

export default MicaPlus;